module.exports = __webpack_public_path__ + "img/fn-goal-8.b5dbf0d2.jpg";